import Typography from '@mui/material/Typography'
import Stack, { StackProps } from '@mui/material/Stack'

interface DiagramProps extends StackProps {
  title?: string
}

export default function Diagram({ title, children, ...props }: DiagramProps) {
  return (
    <>
      {title && (
        <Typography
          variant="body2"
          noWrap
          sx={{
            color: 'contrast.low',
            textAlign: 'center',
            fontSize: '0.75rem',
            marginBottom: 1
          }}>
          {title}
        </Typography>
      )}
      <Stack
        {...props}
        direction="row"
        sx={[{
          alignItems: 'center',
          justifyContent: 'center'
        }, ({ shape }) => ({
          paddingX: { xs: 2, sm: 5 },
          paddingTop: { xs: 2, sm: 4 },
          paddingBottom: { xs: 1, sm: 3 },
          borderRadius: shape.borderRadiusLarge + 'px',
          backgroundColor: 'contrast.paper',
        }), ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
        {children}
      </Stack>
    </>
  )
}
